export default __webpack_public_path__ + "static/media/Path1669.bfddb9b5.png";